// extracted by mini-css-extract-plugin
export var button = "Contract-module--button--8HPzP";
export var component = "Contract-module--component--xVefd";
export var content = "Contract-module--content--hQX2L";
export var label = "Contract-module--label--ayP0A";
export var list = "Contract-module--list--zCotZ";
export var name = "Contract-module--name--bPgCa";
export var title = "Contract-module--title--bA0qB";
export var value = "Contract-module--value--Q4cWP";